import type { Option } from '../../../core/option';
import type StandardChart from '../../../core/StandardChart';
import { DvScatterModel } from './DvScatterModel';

function parse(option: Option, index: number, chart: StandardChart): void {
  const dvScatterSeries = (Array.isArray(option.series) ? option.series : [option.series]).filter(
    item => item.type && item.type === 'dvScatter'
  );
  if (dvScatterSeries.length === 0) {
    return;
  }

  dvScatterSeries.forEach((seriesItem, seriesIndex) => {
    seriesItem.type = 'custom';
    seriesItem.dvType = 'dvScatter';
    const dvScatterModel = new DvScatterModel(chart, seriesIndex, option);
    dvScatterModel.init();
  });
}

export default {
  type: 'dvScatter',
  parse
};
